import React, { useState } from "react";
import ExcelToolbar from "./views/ExcelToolbar";
import { useExportSportEquipmentsInExcelLazyQuery } from "graphql/graphQlApiHooks";
import UploaderService from "services/UplodaService";
import { ImportedSportEquipmentRecord } from "./ImportFromExel/types";
import { ImportFromExcel } from "./ImportFromExel";
import { ImportSelectionDialog } from "./ImportFromExel/ImportSelectionDialog";
import Settings from "store/settings";

import {
  useGetSportEquipmentInputVars
} from "../../../../../../../store/reactiveVarsStores/spor-equipmnts/getSportEquipmentsInput";
import { useSnackbar } from "notistack";


const ExcelTools = () => {
  const [importLoading, setImportLoading] = useState(false);
  const [importedSportEquipmentRecords, setImportedSportEquipmentRecords] = useState<ImportedSportEquipmentRecord[] | null>(null);
  const [importSelectionDialogOpen, setImportSelectionDialogOpen] = useState(false);


  const openImportSelectionDialog = () => {
    setImportSelectionDialogOpen(true);
  };

  const importSportEquipmentListFromExcel = (event: any) => {
    setImportLoading(true);

    UploaderService.uploadImportSportEquipmentFile(event)
      .then((sportEquipmentRecord) => {
        if (sportEquipmentRecord && sportEquipmentRecord.length > 0) {
          setImportedSportEquipmentRecords(sportEquipmentRecord);
        } else {
          enqueueSnackbar("Файл не содержит данных о спортивном оборудовании или имеет неверный формат", { variant: "warning" });
        }
      })
      .catch((error) => {
        console.error("Ошибка при загрузке файла:", error);
        enqueueSnackbar("Ошибка при загрузке файла. Проверьте формат файла и попробуйте еще раз", { variant: "error" });
      })
      .finally(() => {
        setImportLoading(false);
      });

  };

  const [exportSportEquipmentsInExcel, { loading: exportLoading }] = useExportSportEquipmentsInExcelLazyQuery();
  const {getInput} = useGetSportEquipmentInputVars()
  const { enqueueSnackbar } = useSnackbar();
  const exportSportEquipmentListInExcel = () => {
    exportSportEquipmentsInExcel({
      variables: {
        input: getInput()
      }
    }).then((res) => {
      try {
        const data = res.data.exportSportEquipmentsInExcel;
        const fileUrl = `${Settings.server}${data.url}`;
        const fileName = data.name || 'оборудование.xlsx';
        
        // Создаем временную ссылку для скачивания файла
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        enqueueSnackbar("Ошибка при экспорте", { variant: "error" });
      }
    }).catch((err) => {
      enqueueSnackbar(err?.message, { variant: "error" });
    });
  };


  return (
    <>
      <ExcelToolbar
        importLoading={importLoading}
        exportLoading={exportLoading}
        actions={{
          importSportEquipmentListFromExcel: openImportSelectionDialog,
          exportSportEquipmentListInExcel
        }}
      />

      <ImportSelectionDialog
        open={importSelectionDialogOpen}
        onClose={() => setImportSelectionDialogOpen(false)}
        onFileSelect={importSportEquipmentListFromExcel}
        loading={importLoading}
      />

      <ImportFromExcel
        open={!!importedSportEquipmentRecords}
        close={() => {
          setImportedSportEquipmentRecords(null);
        }}
        importedSportEquipmentRecords={importedSportEquipmentRecords}
      />

    </>
  );
};

export default ExcelTools;